module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.dataReady) ? _c('div', {
    staticClass: "article page-404"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h2', [_vm._v("Page not found")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "post-content page-404-content"
  }, [_c('p', [_vm._v("Sorry - the page you requested appears to have been moved, deleted, or does not exist on this site. Please use the navigation above or go to the home page "), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("here")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("We apologies for any inconvenience.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b30acf6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/404.vue
// module id = 349
// module chunks = 0